import { derived, writable } from 'svelte/store'

import { makeUUID } from '$lib/factories'
import { makeInvoice } from '$lib/factories'
import { hints } from '$lib/hints'
import { calculateInvoice } from '$lib/stores/invoice/calculator'
import { payments } from '$lib/stores/payments'
import type { CalculatedInvoice } from '$lib/types/client_types'


/**
 * INVOICE - Stores procedure:
 * 
 * General Description: 
 * 		the process uses: 
 * 			1 store [uncalculated] and 
 * 			1 derived from [uncalculated] named [calculated]
 * 
 * Workflow simple:
 * 		the components read, in reactive form from the [calculated] store
 * 		and realize the update on the [uncalculated], doing so the [calculated] 
 * 		will recalculate with the new values and totals
 *
 * 
 * Workflow complete:
 * 		1. components realize setDocument({new_values}) that updated the [uncalculated]
 * 		2. the [calculated] derived function compares the old values with the new ones 
 *			and sets edited_at=now() => timestamp on changed items. 
 *			This is a flag of the last time the item has changed
 *		3. at some point the debounce of the save funtion will arrive and all the items will be
 * 			sent to the backend 
 * 		4. once the changes have been pushed to the backend, the value of last_saved_at is updated with the new value
 * 
 */




// We have a store of the original invoice, and then a calculated invoice?
// how do we handle payments?

// i don't like the idea of different store accesses, i prefer a writable store
export const uncalculated = writable(makeInvoice(makeUUID))
export let last_saved_at = 0

export function setLastSavedAt(savedAt: number) {
	last_saved_at = savedAt
}

export const calculated = derived([uncalculated, payments], 
	([$uncalculated, $payments]): CalculatedInvoice => {

		const calcInvoice = calculateInvoice($uncalculated, $payments)
		return calcInvoice
	}
)


export const resetInvoiceUncalculated = () => {
	uncalculated.set(makeInvoice(makeUUID))
}


// account_store.subscribe((account) => {
// 	uncalculated.update((existing) => ({
// 		...existing,
// 		color: account.color || DEFAULT_COLOR
// 	}))
// })

uncalculated.subscribe(() => hints.set({}))


 
